import { render } from "./index3.vue?vue&type=template&id=8ff2d6f8"
import script from "./index3.vue?vue&type=script&lang=js"
export * from "./index3.vue?vue&type=script&lang=js"

import "./index3.vue?vue&type=style&index=0&id=8ff2d6f8&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__